import React, { useState, useEffect } from "react";
import {
  Card,
  Container,
  CardBody,
  Button,
  Modal,
  ModalBody
} from "reactstrap";
import TuneIcon from "@mui/icons-material/Tune";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReplayIcon from "@mui/icons-material/Replay";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useApprovalFilter } from "../../Components/Hooks/UseApprovalFilter";
import { myPOList } from "../../api/po";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import {
  fetchFilterListForAllocation
} from "../../api/approval";

const ModalDetails = ({data}) => {

  const [row, setRow] = useState([])

  function CustomCellRenderer(params) {
    return params.value === null ? params.row.total_qty : params.value;
  }
  useEffect(() => {
    if (data?.procurementProductDistribution) {
      const lines = data.procurementProductDistribution.map((item, index) => ({
        ...item,
        Sl_No: ++index
      }))
      setRow(lines)
    }
  }, [data.id])

  const columns = [
    {
      field: "Sl_No",
      headerName: "Sl.No",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 0.5,
      resizable: false,
      sortable: false,
    },
    {
      field: "item_name",
      headerName: "Product Name",
      width: 230,
      resizable: false,
      sortable: false,
      editable: false,
      renderCell: (params) => {
      },
    },
    {
      field: "approve_quantity",
      headerName: "Product Quantity",
      resizable: false,
      sortable: false,
      width: 160,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      renderCell: CustomCellRenderer,

    },
    {
      field: "mop",
      headerName: "FOB",
      resizable: false,
      sortable: false,
      width: 160,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },

  ];
  
  return (
    <>
      <Box sx={{ height: 400, width: "100%", marginBottom: "10px" }}>
        <DataGrid
          className="table_header_background"
          headerClassName="custom-header-cell"
          rows={row}
          columns={columns}
          loading={false} // Set loading state
          initialState={
            {
              // pagination: {
              //     paginationModel: {
              //         pageSize: 5,
              //     },
              // },
            }
          }
          pageSizeOptions={[]}
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
}

const MyPOList = () => {

  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('My PO'))

  

  const [open, setOpen] = useState(false);
  const [showList, setShowList] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
  const [rows, setRows] = useState([]);
  const [modalContent, setModalContent] = useState(null);
  const [vendorList, setVendorList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);


  document.title = "Dashboard | Procurement Dashboard";

  

  const toggleList = () => {
    setShowList(!showList);
  };

  const toggleModal = () => {
    setOpen(prev => !prev)
  }

  const columns = [
    {
      field: "Sl_No",
      headerName: "Sl.No",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 0.7,
      resizable: false,
      sortable: false,
    },

    // {
    //   field: "product_name",
    //   headerName: "Product Name",
    //   // width: 230,
    //   flex: 1,
    //   resizable: false,
    //   sortable: false,
    //   editable: false,
    //   headerAlign: "center",
    //   cellClassName: "center-aligndata",
    //   renderCell: (params) => {
    //     // const productName = params.value;
    //     // return (
    //     //     <div onClick={openModal}>
    //     //         {productName}
    //     //     </div>
    //     // );
    //   },
    // },
    {
      field: "po_number",
      headerName: "PO Number",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      // width: 230,
      flex: 1,
      resizable: false,
      sortable: false,
      editable: false,
      
    },
    {
      field: "po_value",
      headerName: "PO Value",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      // width: 230,
      flex: 1,
      resizable: false,
      sortable: false,
      editable: false,
      
    },
    // {
    //   field: "mop",
    //   headerName: "MOP",
    //   resizable: false,
    //   sortable: false,
    //   // width: 160,
    //   flex: 1,
    //   headerAlign: "center",
    //   cellClassName: "center-aligndata",
    // },
    // {
    //   field: "vendor_name",
    //   headerName: "Vendor Name",
    //   resizable: false,
    //   sortable: false,
    //   // width: 160,
    //   flex: 1,
    //   headerAlign: "center",
    //   cellClassName: "center-aligndata",
    // },
    // {
    //   field: "v_name",
    //   headerName: "System PO Vendor",
    //   resizable: false,
    //   sortable: false,
    //   // width: 160,
    //   flex: 1,
    //   headerAlign: "center",
    //   cellClassName: "center-aligndata",
    // },
    {
      headerName: "Actions",
      flex: 1,
      sortable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      width: 180,
      resizable: false,
      renderCell: (params) => {
        return <span><VisibilityOutlinedIcon sx={{color: "#5A6871"}} onClick={() => handleRowClick(params)}/></span>;
      },
    },
  ];

  const fetchPoList = async (payload = {}) => {
    try {
      setIsLoading(true);



      const response = await myPOList(payload);

      let poItems= [];
      if (
        response.statusCode === 200 &&
        response.data.sysPoList.length > 0
      ) {
        poItems = response.data.sysPoList.map((item, index) => ({
          ...item,
          erp_po_no: item.procurementErpPODetails ? item.procurementErpPODetails.PONUMBER : '--',
          erp_pr_no: item.procurementErpPRDetails? item.procurementErpPRDetails.PRNumber: '--',
          Sl_No: ++index,
        }));
        // Update rows state with fetched data
      }
      setRows(poItems);
    } catch (error) {
      console.error("Error fetching Purchase Orders:", error);
      toast.error("Something went wrong");
      // Handle error
    } finally {
      setIsLoading(false); // Reset loading state after operation completes
    }
  };


  

  useEffect(() => {
    fetchFilterList();
    fetchPoList();
  }, []);

  const handleRowClick = (params) => {
    toggleModal();
    console.log(params.row)
    setModalContent(params.row);
  };
  const handleVendorSelect = (e, myvalue) => {
    setSelectedVendor(myvalue || null);
  };
  const handleProductSelect = (e, myvalue) => {
    setSelectedProduct(myvalue || null);
  };
  const handleCategorySelect = (e, myvalue) => {
    setSelectedCategory(myvalue || null);
  };

  const fetchFilterList = async () => {
    try {

        const list = await fetchFilterListForAllocation({filter_type:['product', 'category','vendor'], isMyPO: 'myPO'});
        
        setProductList(
          list.data.response.productList
        );
        setCategoryList(
          list.data.response.categoryList
        );
        setVendorList(
          list.data.response.vendorList
        );
    
    } catch (error) {
      toast.error("Error in fetching filter list for MY PO");
      console.log(error);
    }
  };

  const searchList = async () => {
    let payload = {}
    if(selectedCategory){
      payload.category = selectedCategory.value
    }
    if(selectedProduct){
      payload.product = selectedProduct.value
    }
    if(selectedVendor){
      payload.vendor = selectedVendor.value
    }
    if(selectedDate){
      payload.startDate = dayjs(selectedDate).format('YYYY-MM-DD');
    }
    if(selectedEndDate){
      payload.endDate = dayjs(selectedEndDate).format('YYYY-MM-DD');
    }
    await fetchPoList(payload)
  };

  const handleReset = ()=>{
    setSelectedCategory(null)
    setSelectedProduct(null)
    setSelectedDate(null)
    setSelectedEndDate(null)
    setSelectedVendor(null)
    fetchPoList()
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="My Requisition" pageTitle="Requisitions"/> */}
          <div>
            <div className="mb-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: "20px" }}>
                <h3 className="requisition_text mb-0">PO List</h3>
              </div>
              {/* <div>
                <Button
                  onClick={toggleList}
                  variant="outlined"
                  className="filter_button"
                >
                  <span className="me-2">
                    <TuneIcon />
                  </span>
                  Filter
                </Button>
              </div> */}
            </div>
           
            {showList && (
              <div className="d-flex align-items-center gap-2">
                <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="combo-box-demo"
                    options={vendorList}
                    sx={{ width: 230 }}
                    value={selectedVendor}
                    onInputChange={(event, newValue) => handleVendorSelect(event, vendorList.find(el => el.label == newValue))}
                          onChange={(event, newValue) => handleVendorSelect(event, newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Vendor" />
                    )}
                  />
                </div>
                <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="combo-box-demo"
                      options={productList}
                      sx={{ width: 230 }}
                      value={selectedProduct}

                      onInputChange={(event, newValue) => handleProductSelect(event, productList.find(el => el.label == newValue), 'product')}
                      onChange={(event, newValue) => handleProductSelect(event, newValue, 'product')}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Product" />
                      )}
                    />
                </div>
                <div>
                  <Autocomplete
                      className="data_field"
                      disablePortal
                      id="combo-box-demo"
                      options={categoryList}
                      sx={{ width: 230 }}
                      value={selectedCategory}
                      onInputChange={(event, newValue) => handleCategorySelect(event, categoryList.find(el => el.label == newValue), 'category')}
                      onChange={(event, newValue) => handleCategorySelect(event, newValue, 'category')}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Category" />
                      )}
                  />
                </div>
                <div className="d-flex">
                  <div>
                    <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                        <DatePicker className='date_picker'
                          label="From Date"
                          value={dayjs(selectedDate)}
                          maxDate={selectedEndDate}

                          onChange={(e) => {
                            setSelectedDate(e)
                          }}
                          sx={{ width: 200 }}
                        />
                      </LocalizationProvider>
                  </div>
                  <div className="ms-2">
                    <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                          <DatePicker className='date_picker'
                            label="To Date"
                            value={dayjs(selectedEndDate)}
                        minDate={selectedDate}

                            onChange={(e) => {
                              setSelectedEndDate(e)
                            }}
                            sx={{ width: 200 }}
                          />
                      </LocalizationProvider>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                    <button className="me-2 search_button" variant="outlined" onClick={searchList}>Search</button>
                    <ReplayIcon onClick={handleReset} />
                </div>
              
              </div>
            )}
            <Box sx={{ height: '100%', width: "100%", marginBottom: "10px", marginTop: '10px' }}>
             
              <DataGrid
                 autoHeight
                className="table_header_background"
                headerClassName="custom-header-cell"
                rows={rows}
                columns={columns}
                loading={isLoading} // Set loading state
                initialState={
                  {
                    // pagination: {
                    //     paginationModel: {
                    //         pageSize: 5,
                    //     },
                    // },
                  }
                }
                pageSizeOptions={[]}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnResize={true}
                componentsProps={{
                    cell: {
                        disableClick: true,
                    },
                }}
                sx={{
                    '& .MuiDataGrid-cell': {
                        '& .MuiDataGrid-cell--textOverflow': {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        },
                    },
                }}
              />
            </Box>
          </div>
          {/* <Card>
                        <CardBody className="ps-0 pe-0 pt-0">
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total FOB</th>

                                            <th className="text-center">Total PO Amount</th>

                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{rows.length}</td>
                                                <td className="text-center">{rows.map(el => el.procurementProductDistribution.map(item => item.approve_quantity || 0)).flat().reduce((accumulator, currentObject) => {
                                                  return accumulator + Number(currentObject);
                                                }, 0)}</td>
                                                <td className="text-center">{rows.map(el => el.procurementProductDistribution.map(item => item.mop)).flat().reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject;
                                                }, 0).toFixed(2)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                    return accumulator + currentObject.po_total_value;
                                                  }, 0).toFixed(2)}</td>
                                            </tr>
                                        
                                    </tbody>
                                  
                                </table>
                            </div>
                        </CardBody>
                    </Card> */}
        </Container>
        <Modal
          isOpen={open}
          toggle={toggleModal}
          contentLabel="Example Modal"
          >
            {modalContent && <>
              <div className='d-flex justify-content-between me-2 mt-3'>
                <h4 className='ms-3'>{modalContent.po_number}</h4>
                <div className='d-flex justify-content-end me-3 modal_close'>
                    <i class="ri-close-line" onClick={toggleModal}></i>
                </div>
              </div>
              <hr className='mb-2 mt-1 ms-3 me-3'></hr>
              <ModalBody className='pt-2'>
                <ModalDetails data={modalContent}/>
              </ModalBody>
            </>
            }
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default MyPOList;